import { SvgIcon } from '@mui/material';

export default function HouseIcon({ ...props }) {
  return (
    <SvgIcon {...props}>
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3 20.25V10.5H4.5V20.25C4.5 20.4489 4.57902 20.6397 4.71967 20.7803C4.86032 20.921 5.05109 21 5.25 21H18.75C18.9489 21 19.1397 20.921 19.2803 20.7803C19.421 20.6397 19.5 20.4489 19.5 20.25V10.5H21V20.25C21 20.8467 20.7629 21.419 20.341 21.841C19.919 22.2629 19.3467 22.5 18.75 22.5H5.25C4.65326 22.5 4.08097 22.2629 3.65901 21.841C3.23705 21.419 3 20.8467 3 20.25ZM19.5 3.75V9L16.5 6V3.75C16.5 3.55109 16.579 3.36032 16.7197 3.21967C16.8603 3.07902 17.0511 3 17.25 3H18.75C18.9489 3 19.1397 3.07902 19.2803 3.21967C19.421 3.36032 19.5 3.55109 19.5 3.75Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.9404 2.25168C11.2217 1.97047 11.6032 1.8125 12.0009 1.8125C12.3987 1.8125 12.7802 1.97047 13.0614 2.25168L23.0319 12.2207C23.1728 12.3615 23.2519 12.5525 23.2519 12.7517C23.2519 12.9508 23.1728 13.1418 23.0319 13.2827C22.8911 13.4235 22.7001 13.5026 22.5009 13.5026C22.3018 13.5026 22.1108 13.4235 21.9699 13.2827L12.0009 3.31218L2.03195 13.2827C1.89112 13.4235 1.70011 13.5026 1.50095 13.5026C1.30178 13.5026 1.11078 13.4235 0.969947 13.2827C0.829117 13.1418 0.75 12.9508 0.75 12.7517C0.75 12.5525 0.829117 12.3615 0.969947 12.2207L10.9404 2.25168Z'
          fill='currentColor'
        />
      </svg>
    </SvgIcon>
  );
}
